export default "__VITE_ASSET__914b21b1__"